import Vue from 'vue';

Vue.component('fnb-stock-index', () =>
    import(/* webpackChunkName: 'index' */ './stock-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/stock/index.js